import { render, staticRenderFns } from "./eventHome.vue?vue&type=template&id=cb503590&scoped=true&xmlns=true"
import script from "./eventHome.vue?vue&type=script&lang=js"
export * from "./eventHome.vue?vue&type=script&lang=js"
import style0 from "./eventHome.vue?vue&type=style&index=0&id=cb503590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb503590",
  null
  
)

export default component.exports